import { Component, OnInit, Inject } from '@angular/core';

//MATERIAL
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

//UTILS
import { ESalesOrderStatus } from 'v2/modules/order/interfaces/order.interface';

import { SnackBarConfig } from '../../../shared/configs/snackbar.config';
import { trackByValue } from '../../../shared/util/track-by.util';

//FORMS

//CONFIG

export interface ISalesOrderUpdateStatusFormResult {
  orderStatus :string;
  trackingNumber :string | null;
  carrierCode :string | null;
}

@Component({
  selector: 'lum-sales-order-update-status-form',
  templateUrl: './sales-order-update-status-form.component.html',
  styleUrls: ['./sales-order-update-status-form.component.scss'],
})
export class SalesOrderUpdateStatusFormComponent implements OnInit {
  salesOrderStatus = ESalesOrderStatus;
  source :string;
  statusValues :string[];
  hideAdditionalFields :boolean;
  form :UntypedFormGroup;
  trackByValue = trackByValue;
  constructor(
    public dialogRef :MatDialogRef<SalesOrderUpdateStatusFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{
      title :string;
      orderStatus :string[];
      hideAdditionalFields :boolean;
      source :string;
    },
    private fb :UntypedFormBuilder,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    // Convert the object values to an array
    this.statusValues = Object.values(this.data.orderStatus);
    this.hideAdditionalFields = this.data.hideAdditionalFields ?? true;
    this.source = this.data.source ?? null;
    this.initForm();
  }

  onSubmit() :void {
    if (!this.form.valid) {
      this.snackBar.open('At least one option is required in the field', 'Fail', {
        duration: SnackBarConfig.DEFAULT.duration,
      });
    }
    this.dialogRef.close({
      orderStatus: this.form.get('orderStatus')?.value.toLowerCase(),
      trackingNumber: this.form.get('trackingNumber')?.value,
      carrierCode: this.form.get('carrierCode')?.value,
    });
  }

  onClose() :void {
    this.dialogRef.close(null);
  }

  private initForm() :void {
    this.form = this.fb.group({
      orderStatus: [
        this.source === 'picklist' ? 'SHIPPED' : '',
        Validators.required,
      ],
      trackingNumber: [null],
      carrierCode: [null],
    });

    this.handleStatusChange();

    if (this.source === 'picklist') {
      this.form
        .get('orderStatus')
        ?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }
  }

  private handleStatusChange() :void {
    if (this.hideAdditionalFields) {
      return;
    }

    this.form.get('orderStatus')?.valueChanges.subscribe((orderStatus) => {
      if (orderStatus !== ESalesOrderStatus.SHIPPED.toUpperCase()) {
        this.form.get('trackingNumber')?.reset(null);
        this.form.get('carrierCode')?.reset(null);
      }

      this.form.get('trackingNumber')?.updateValueAndValidity();
      this.form.get('carrierCode')?.updateValueAndValidity();
    });
  }
}
